import React, { useMemo } from "react";
import {
  formatDateIntoDMYToDisplay,
  gethoursAndMins,
  splitDmyDisplayDatePrefixAndYear,
} from "Utils/utils";
import CheckBox from "../../../../../components/common/checkBox/checkbox";
import { getCaseNoteSupportItemDisplayName } from "Utils/caseNoteSupportItem";

const COSInvoiceTabel = (props) => {
  const { item, checkboxes, handleCheckboxChange, isUserGracePeriodOver, isNewMode = true } =
    props;

  const showDataInTable = (item) => {
    const parsedData = JSON.parse(item.manged_by);
    const data = [];
    const filtedData = parsedData.filter((items) => {
      return items.label !== "NDIA Managed";
    });
    filtedData.forEach((element) => {
      data.push(element.label);
    });
    return data;
  };

  const mgmtLabel = useMemo(() => showDataInTable(item).join(", "), [item]);

  const dateDeliveredLabel = useMemo(() => {
    if (item.delivered_from && item.delivered_to_date) {
      return `${formatDateIntoDMYToDisplay(
        item.delivered_from
      )} - ${formatDateIntoDMYToDisplay(item.delivered_to_date)}`;
    }
    if (item.delivered_date) {
      return formatDateIntoDMYToDisplay(item.delivered_date);
    }
    return "-";
  }, [item]);

  const rateVal =
    item.alternative_rate && parseFloat(item.alternative_rate) > 0
      ? parseFloat(item.alternative_rate)
      : parseFloat(item.original_rate);

  const createdAtDisplay = formatDateIntoDMYToDisplay(item.created_at);
  const createdAtParts = splitDmyDisplayDatePrefixAndYear(createdAtDisplay);
  const supportItemDisplay = useMemo(
    () => getCaseNoteSupportItemDisplayName(item),
    [item]
  );

  return (
    <tr className='even:bg-white odd:bg-gray-50'>
      <td className='w-[3%] px-0.5 py-3 align-top text-center text-sm text-gray-500'>
        <CheckBox
          isDisabled={isUserGracePeriodOver}
          handleChange={handleCheckboxChange}
          checked={checkboxes.indexOf(item.id) !== -1}
        />
      </td>
      <td className='w-[6%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 text-left'>
        <div className='truncate' title={String(item.delivered_service_number ?? "")}>
          {item.delivered_service_number}
        </div>
      </td>
      <td className='w-[6%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 capitalize text-left'>
        <div className='truncate' title={String(item.created_by ?? "")}>
          {item.created_by}
        </div>
      </td>
      <td className='w-[6%] min-w-0 px-2 py-3 align-top text-left text-sm text-gray-500'>
        <div className='leading-tight' title={createdAtDisplay}>
          {createdAtParts.year ? (
            <>
              <span>{createdAtParts.prefix}</span>
              <wbr />
              <span className='whitespace-nowrap'>{createdAtParts.year}</span>
            </>
          ) : (
            <span className='break-words'>{createdAtDisplay}</span>
          )}
        </div>
      </td>
      {isNewMode && (
        <td className='w-[10%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 capitalize text-left'>
          <div className='truncate' title={String(item.participant ?? "")}>
            {item.participant}
          </div>
        </td>
      )}
      <td className='w-[8%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 text-left'>
        <div className='truncate' title={mgmtLabel}>
          {mgmtLabel}
        </div>
      </td>

      <td className='w-[11%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 text-left'>
        <div className='truncate' title={String(supportItemDisplay ?? "")}>
          {supportItemDisplay}
        </div>
      </td>
      <td className='w-[7%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 text-left'>
        <div className='truncate' title={String(item.support_item_number ?? "")}>
          {item.support_item_number}
        </div>
      </td>
      <td className='w-[6%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 text-left'>
        <div
          className='truncate'
          title={
            item?.invoice_status === "ready_for_extraction"
              ? "Ready For Extraction"
              : ""
          }
        >
          {item?.invoice_status === "ready_for_extraction" &&
            "Ready For Extraction"}
        </div>
      </td>
      <td className='w-[12%] min-w-0 px-2 py-3 align-top text-sm text-gray-500 text-left'>
        <div className='truncate' title={dateDeliveredLabel}>
          {dateDeliveredLabel}
        </div>
      </td>
      <td className='w-[4%] px-2 py-3 align-top text-sm text-gray-500 whitespace-nowrap text-right tabular-nums'>
        {item.km || 0}
      </td>
      <td className='w-[5%] px-2 py-3 align-top text-sm text-gray-500 whitespace-nowrap text-right'>
        {gethoursAndMins(item?.hours, item?.mints)}
      </td>
      <td className='w-[5%] px-2 py-3 align-top text-sm text-gray-500 whitespace-nowrap text-right tabular-nums'>
        {`$${rateVal}`}
      </td>
      <td className='w-[8%] px-2 py-3 align-top text-sm text-gray-500 whitespace-nowrap text-right tabular-nums'>
        {`$${item.total_amount}`}
      </td>
      <td className='w-[3%] px-1 py-3 align-top' aria-hidden='true' />
    </tr>
  );
};

export default COSInvoiceTabel;
